<style lang="scss">
  @use "../../../../assets/css/design-system/mixins";
  @use "../../../../assets/css/design-system/utils";
  @use "../../../../assets/css/design-system/colors";

  .time-lists-container {
    display: flex;
    gap: utils.in_rem(8px);

    &:hover .separator {
      opacity: 1;
    }
  }

  .time-list {
    display: flex;
    flex-direction: column;
    width: utils.in_rem(44.5px);
    max-height: utils.in_rem(170px);
    padding: 0 utils.in_rem(4px);
    overflow-y: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .separator {
    width: 2px;
    background: colors.get(interfaceSwGrey_10);
    flex-shrink: 0;
    align-self: stretch;
    opacity: 0;
    transition: opacity 0.2s;
    height: utils.in_rem(154px);
    padding: utils.in_rem(2px);
  }

  .time-selector-button {
    display: flex;
    align-items: center;
    gap: utils.in_rem(8px);
    padding: utils.in_rem(6px) utils.in_rem(12px);
    border-radius: 10px;
    border: 1px solid colors.get(interfaceSwGrey_10);
    @include colors.background-color(interfaceWhite);
    @include mixins.body2();
    outline: none;
    .button-text {
      @include colors.color(textGrey);

      &:hover {
        @include colors.color(primary_50);
      }
    }

    &:focus {
      outline: none;
    }
  }
</style>

<script>
  import Icon from "../../../atoms/Icon.svelte";
  import Dropdown from "../../Dropdown/Dropdown.svelte";
  import TimeSelectorItem from "./TimeSelectorItem.svelte";

  let { disabled = false, selectedTime = $bindable("18:00") } = $props();

  const hours = Array.from({ length: 24 }, (_, i) =>
    i.toString().padStart(2, "0")
  );
  const minutes = Array.from({ length: 60 }, (_, i) =>
    i.toString().padStart(2, "0")
  );

  const selectedHour = $derived(
    selectedTime ? selectedTime.split(":")[0] : "18"
  );
  const selectedMinute = $derived(
    selectedTime ? selectedTime.split(":")[1] : "00"
  );

  const selectHour = (hour) => {
    selectedTime = `${hour}:${selectedMinute}`;
  };

  const selectMinute = (minute) => {
    selectedTime = `${selectedHour}:${minute}`;
  };
</script>

<Dropdown {disabled} placement="bottom" dynamicWidth={false}>
  {#snippet purebutton()}
    <div class="time-selector-button">
      <span class="button-text">{selectedHour}:{selectedMinute}</span>
      <Icon class="fa-regular fa-clock button-icon color-textGrey" />
    </div>
  {/snippet}
  <div class="time-lists-container">
    <div class="time-list">
      {#each hours as hour}
        <TimeSelectorItem
          selected={hour === selectedHour}
          onclick={() => selectHour(hour)}
        >
          {hour}
        </TimeSelectorItem>
      {/each}
    </div>
    <div class="separator"></div>
    <div class="time-list">
      {#each minutes as minute}
        <TimeSelectorItem
          selected={minute === selectedMinute}
          onclick={() => selectMinute(minute)}
        >
          {minute}
        </TimeSelectorItem>
      {/each}
    </div>
  </div>
</Dropdown>
